module.exports = __webpack_public_path__ + "static/media/visa-4.95456470.svg";